import React from 'react';
import './styles.css';

interface Props {
  number: number;
  suffix?: string;
}

export const ScoreBoardNumber: React.FC<Props> = ({ number, suffix }) => (
  <div className="scoreboard-container">
    <span className="scoreboard">{number.toString().padStart(2, '0')}</span>
    {suffix && <span className="suffix">{suffix}</span>}
  </div>
);
